export const languageStrings = {
  English: {
    proArt: "ProArt",
    cart: "Cart",
    home: "Home",
    products: "Products",
    wishlist: "WishList",
    addToCart: "Add To Cart",
    new: "New",
    moveToWishlist: "Move To Wishlist",
    moveToCart: "Move To Cart",
    buyNow: "Buy Now",
    taxIncluded: "Tax Included",
    description: "Description",
    quantity: "Quantity",
    price: "Price",
    save: "Save",
    shop: "Shop",
    off: "off",
    placeOrder: "Place Order",
    viewDetails: "View Details",
    priceDetails: "Price Details",
    discountOnMRP: "Discount On MRP",
    totalMRP: "Total MRP",
    couponDiscount: "Coupon Discount",
    applyCoupon: "Apply Coupon",
    convenienceFee: "Convenience Fee",
    addMoreFromWishlist: "Add More From WishList",
    cartIsEmpty: "Cart Is Empty",
    totalAmount: "Total Amount",
    cardHolderName: "CardHolder Name",
    cardNumber: "Card Number",
    date: "Date",
    CVV: "CVV",
    paymentDetails: "Payment Details",
    pay: "Pay",
    login: "Login",
    logout: "Logout",
    eMail: "E-Mail",
    password: "Password",
    submit: "Submit",
    item: "item",
    selectDeliveryAddress: "Select Delivery Address"
  },
  Hindi: {
    proArt: "प्रोआर्ट",
    cart: "झोला",
    home: "घर",
    products: "उत्पादों",
    wishlist: "इच्छा-सूची",
    addToCart: "झोले में जोड़ें",
    new: "नया",
    moveToWishlist: "इच्छा सूची में जोड़ें",
    moveToCart: "झोले में जोड़ें",
    buyNow: "अभी खरीदें",
    taxIncluded: "कर सहित",
    description: "विवरण",
    quantity: "मात्रा",
    price: "कीमत",
    save: "बचत",
    shop: "दुकान",
    off: "छूट",
    placeOrder: "अभी ख़रीदे",
    viewDetails: "विस्तार में विवरण",
    priceDetails: "कीमत का विस्तार",
    discountOnMRP: "कीमत पर छूट",
    totalMRP: "संपूर्ण कीमत",
    couponDiscount: "कूपन छूट",
    applyCoupon: "कूपन लगाए",
    convenienceFee: "सुविधा शुल्क",
    addMoreFromWishlist: "इच्छा-सूची से झोला में डालें",
    cartIsEmpty: "झोला खाली है",
    totalAmount: "संपूर्ण रकम",
    cardHolderName: "कार्डधारक का नाम",
    cardNumber: "कार्ड नंबर",
    date: "तारीख",
    CVV: "सी. वी. वी.",
    paymentDetails: "रकम विस्तार",
    pay: "मूल्य",
    login: "लॉग इन",
    logout: "लॉग आउट",
    eMail: "ईमेल",
    password: "पासवर्ड",
    submit: "जमा करे",
    item: "वस्तु",
    selectDeliveryAddress: "पता चुने"
  }
};
